/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationBatchDto } from '../../models/notification-batch-dto';
import { PageInfoDto } from '../../models/page-info-dto';

export interface NotificationBatchAdminControllerSearchV1$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 알림 유형 (예: notice)
 */
  notificationType?: string;
}

export function notificationBatchAdminControllerSearchV1(http: HttpClient, rootUrl: string, params: NotificationBatchAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<NotificationBatchDto>;
'pageInfo': PageInfoDto;
}>> {
  const rb = new RequestBuilder(rootUrl, notificationBatchAdminControllerSearchV1.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('notificationType', params.notificationType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'items': Array<NotificationBatchDto>;
      'pageInfo': PageInfoDto;
      }>;
    })
  );
}

notificationBatchAdminControllerSearchV1.PATH = '/api/v1/notification-batches/admin/search';
